// extracted by mini-css-extract-plugin
export default {"wrapper":"loading-round_wrapper__bBHUy","inner":"loading-round_inner__KEIsq","modal":"loading-round_modal__20nLk"};